export default {
    "orderno": "",
    "cafsno": "",
    "svcno": "",
    "svctype": "",
    "ordertype": "",
    "dateinstall": "",
    "orderstatus": "",
    "region": "",
    "bpid": "",
    "bpopid": "",
    "remarks": "",
    "ordertotalcost": "",
    "dummycost": "",
    "dummyextras": "",
    "dummyfiles": "",
}
